<template>
  <div class="unishop-item">
    <a class="flex-column">
     <div class="unishop-item-photo">
        <div class="unishop-item-thumbs">
          <a class="unishop-modal-link">
              <img :src="imagen">
          </a>
        </div>
      </div>
      
        <div class="unishop-item-name w-100">
          <h2 class="primary-color h5 text-uppercase mb-0 font-weight-medium">
            {{ producto.modelo }}
          </h2>
          <p class="d-flex mb-0">
             {{ producto.color }}
          <span class="no-flex my-0 h5 ml-auto floar-right font-weight-black">
            {{ precio }} €
          </span>
          </p>
      </div>
    </a>
  </div>
</template>
<script>
export default {
  name: 'clienteArticulo',
  props: {
    producto: {
      type: Object,
      required: true
    },
    foto: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      opId: this.$store.getters.getIdTienda,
      options: {
        rewind: false,
        gap   : '2px',
        fixedWidth : '200px',
        arrows: true,
        pagination: false
      },
      precio: '',
      imagen: ''
    }
  },
  computed: {
    cambiotienda () {
      return this.$store.getters.getIdTienda;
    },
  },
  watch: {
    cambiotienda (value) {
      this.opId = value;
      this.init();
    },
  },
  created() {
    this.imagen = this.foto
    this.getFotos()
    this.init()
  },
  methods: {
    init () {
      this.getPrecio()
    },
    getFotos() {
      if (this.producto.fotos) {
        for (var i = 0; i < this.producto.fotos.length; i++) {
          if (this.producto.fotos[i].porDefecto === "S") {
            if (this.producto.fotos[i].url) {
              this.imagen = this.producto.fotos[i].url
            } else {
              this.imagen = ("data:image/png;base64," + this.producto.fotos[i].imagenBytes)
            }
          } else {
            if (this.producto.fotos[i].url) {
              if (this.imagen === '') {
                this.imagen = this.producto.fotos[i].url
              }
            } else {
              if (this.imagen === '') {
                this.imagen = ("data:image/png;base64," + this.producto.fotos[i].imagenBytes)
              }
            }
          }
        }
      }
      if (this.imagen === '') {
        this.imagen = require('@/assets/images/noimg.jpg')
      }
    },
    getPrecio() {
      if (this.producto.precio) {
        this.precio = this.producto.precio
      } else {
        // si queremos sacar el precio de la tienda
        for (var i = 0; i < this.producto.tallas.length; i++) {
          for (var y = 0; y < this.producto.tallas[i].stocks.length; y++) {
            if (this.producto.tallas[i].stocks[y].id.id_op == this.opId) {
              if (this.producto.tallas[i].stocks[y].precio){
                this.precio=this.producto.tallas[i].stocks[y].precio.precio
                break
              }
            } else {
              if (this.producto.tallas[i].stocks[y].precio) {
                this.precio=this.producto.tallas[i].stocks[y].precio.precio
              }
            }
          }
        }
      }
    }
  },
}
</script>